import React from 'react';
import { Clock, HardDrive } from 'lucide-react';
import { cn } from '../../utils/cn';

export interface HistoryPickerItemProps {
  item: {
    fileId: string;
    filename: string;
    displayName: string;
    agentName: string;
    timestamp: string | Date;
    sizeBytes: number;
  };
  isActive: boolean;
  onClick: () => void;
}

export const HistoryPickerItem: React.FC<HistoryPickerItemProps> = ({
  item,
  isActive,
  onClick,
}) => {
  const dateStr = new Date(item.timestamp).toLocaleString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });

  const formatSize = (bytes: number) => {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
  };

  return (
    <button
      type="button"
      onClick={onClick}
      className={cn(
        "w-full px-4 py-2.5 flex flex-col gap-0.5 border-b border-outline-variant/10 text-left transition-colors",
        isActive 
          ? "bg-primary/10 text-on-surface" 
          : "hover:bg-surface-container-high/60 text-secondary"
      )}
    >
      <div className="flex items-center justify-between gap-2">
        <span className="text-sm font-bold text-on-surface font-display">
          @{item.displayName}
        </span>
        <span className="text-[10px] px-2 py-0.5 rounded bg-primary-fixed text-primary font-bold uppercase tracking-tight">
          {item.agentName}
        </span>
      </div>
      <div className="flex items-center gap-3 text-[10px] text-secondary/70 mt-0.5">
        <div className="flex items-center gap-1">
          <Clock className="w-3.5 h-3.5" />
          <span>{dateStr}</span>
        </div>
        <div className="flex items-center gap-1">
          <HardDrive className="w-3.5 h-3.5" />
          <span>{formatSize(item.sizeBytes)}</span>
        </div>
      </div>
    </button>
  );
};
